import { db } from "../../App/deployments/firebase";

// Top-level Firestore collection for adaptive-flow instrumentation, with one
// fixed doc ("log") holding the "latency" and "errors" subcollections.
const adaptiveFlowLogDoc = db.collection("adaptive_flow_log").doc("log");

/**
 * Logs a single adaptive trials request's round-trip latency (plus the request
 * payload, for debugging) to Firestore. Fire-and-forget - a failure here must
 * never block the adaptive trials flow.
 * @param {Object} record
 */
export function saveAdaptiveFlowLatency(record) {
  adaptiveFlowLogDoc
    .collection("latency")
    .add(record)
    .catch((error) => {
      console.warn("[AdaptiveFlowLog] Failed to save latency record to Firebase:", error);
    });
}

/**
 * Logs an adaptive trials failure (fetch failed, empty/invalid response,
 * unsupported trialType, etc.) to Firestore. Fire-and-forget - a failure here
 * must never block the adaptive trials flow (which is already heading to the
 * connection-error screen by the time this is called).
 * @param {Object} record
 */
export function saveAdaptiveFlowError(record) {
  adaptiveFlowLogDoc
    .collection("errors")
    .add(record)
    .catch((error) => {
      console.warn("[AdaptiveFlowLog] Failed to save error record to Firebase:", error);
    });
}
